export default "__VITE_ASSET__B_jiFBL8__"